<div class="reject-seller-container">
    <div class="card">
        <div class="card-header">
            <h5>Reject Seller Account</h5>
        </div>
        <div class="card-body">
            <form [formGroup]="rejectForm" (ngSubmit)="onSubmit()">
                <div class="form-group mb-3">
                    <label for="reason">Reason for Rejection <span class="text-danger">*</span></label>
                    <textarea 
                        id="reason" 
                        class="form-control" 
                        rows="5" 
                        formControlName="reason"
                        [ngClass]="{ 'is-invalid': submitted && f.reason.errors }">
                    </textarea>
                    <div *ngIf="submitted && f.reason.errors" class="invalid-feedback">
                        <div *ngIf="f.reason.errors.required">Reason is required</div>
                        <div *ngIf="f.reason.errors.minlength">Reason must be at least 10 characters</div>
                        <div *ngIf="f.reason.errors.maxlength">Reason must not exceed 500 characters</div>
                    </div>
                    <small class="form-text text-muted">
                        Please provide a detailed reason for rejection (10-500 characters)
                    </small>
                </div>

                <div class="d-flex justify-content-end gap-2">
                    <button type="button" class="btn btn-secondary" (click)="onCancel()">
                        Cancel
                    </button>
                    <button type="submit" class="btn btn-danger" [disabled]="rejectForm.invalid">
                        Confirm Rejection
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
